var previewRequest = function (serverDomain, link, successAction, errorAction, isProduction) {
  if (isProduction === undefined) isProduction = true;
  if (errorAction === undefined) errorAction = console.warn;
  var protocol = isProduction ? 'https' : 'http';
  var url = protocol + '://' + serverDomain + '/?link=' + link;
  var xhrPreviewRequest = new XMLHttpRequest();
  xhrPreviewRequest.open('GET', url, true);
  xhrPreviewRequest.onload = function onRequestLoaded() {
    if (xhrPreviewRequest.status >= 200 && xhrPreviewRequest.status < 400) {
      var response = JSON.parse(xhrPreviewRequest.response);
      successAction(response);
    } else {
      var error = JSON.parse(xhrPreviewRequest.response).error;
      errorAction(error);
    }
  };
  xhrPreviewRequest.send(null);
};
export default previewRequest;